import { useState } from 'react';
import classNames from 'classnames';
import type { AutocompleteProps } from '$components/basic/Autocomplete';
import { Autocomplete } from '$components/basic/Autocomplete';
import { Image } from '$components/basic/Image';
import { useRenderAfterHydration } from '$util/hooks/useRenderAfterHydration';
import { Styled } from './styled';

export type SearchSuggestionsDesktopProps<TSuggestion, TSection = unknown> = AutocompleteProps<
  TSuggestion,
  TSection
>;

export function SearchSuggestionsDesktop<TSuggestion, TSection = unknown>({
  className,
  ...props
}: SearchSuggestionsDesktopProps<TSuggestion, TSection>) {
  const [inputInFocus, setInputInFocus] = useState(false);
  // Prepare icon for smooth transition
  const initSearchIconHover = useRenderAfterHydration();

  const onFocus = () => {
    setInputInFocus(true);
  };

  const onBlur = () => {
    setInputInFocus(false);
  };

  const searchIcon = (
    <div className="search-icon">
      <Image
        provider="cloudinary"
        src="/icons/search_tcabyq.svg"
        alt="search"
        layout="fixed"
        width="19"
        height="20"
      />
      <Image
        provider="cloudinary"
        src="/icons/search_dark_s1t0rn.svg"
        alt="search"
        layout="fixed"
        width="19"
        height="20"
        loading={initSearchIconHover ? 'eager' : undefined}
      />
    </div>
  );

  return (
    <Styled className={classNames('SearchSuggestionsDesktop', className)}>
      <Autocomplete<TSuggestion, TSection>
        className={classNames(inputInFocus && '-inputInFocus')}
        prefix={searchIcon}
        onFocus={onFocus}
        onBlur={onBlur}
        {...props}
      />
    </Styled>
  );
}
SearchSuggestionsDesktop.displayName = 'SearchSuggestionsDesktop';
